import './App.css';
import {useState, useEffect} from 'react';
import {HashRouter as Router, Routes, Route, Link} from 'react-router-dom';
import Home from './Home';
import Contact from './Contact';
import About from './About';
import Projects from './Projects';
import NavigationBar from './NavigationBar';
import ModeButton from './modeButton';
import emailjs from '@emailjs/browser';

function App() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);
  const [page, setPage] = useState(
  window.location.href.includes('about') ? 'about' :
  window.location.href.includes('contact') ? 'contact' :
  window.location.href.includes('projects') ? 'projects' :
  'home'
  );
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      setCurrentTime(now);
      const hours = now.getHours();
      const morningOrEvening = hours >= 12 && hours < 17 ? 'Afternoon' : hours >= 17 ? 'evening' : 'morning' ;
      setGreeting(`Good ${morningOrEvening},`);
    }, 10);

    
    return () => clearInterval(intervalId);
  },[]);

const date = new Date();
const hour = date.getHours();


  const [mode, setMode] = useState(hour >= 17 ? 'dark' : 'light');

  useEffect(() => {
    document.body.style.backgroundColor = mode === 'dark' ? '#28282b' : '#f1eee6';
  }, [mode]);
  
  

  
  

  const [greeting, setGreeting] = useState(``);
  const [viewMode , setViewMode] = useState(
  screenSize.width > 768 ? 'desktop' :
  screenSize.width <= 768 && screenSize.width > 414 ? 'tablet' :
  screenSize.width <= 414 ? 'mobile' :
  'unknown'
  )




  
  
 

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
      
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    
  }, []);



useEffect(() => {
  const handleMouseMove = (e) => {
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    setMouseX(mouseX);
    setMouseY(mouseY);
  }

  document.addEventListener('mousemove', handleMouseMove);

  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
  }
}, []);

function handleModeSelect() {
  if (mode === 'light') {
    setMode('dark');
  } else if (mode === 'dark') {
    setMode('light');
  }
}

(function(){
  emailjs.init({
    publicKey: "RWizanIvkumNJFqQ5",
  });
})();







return (
  <div style={{
    backgroundColor: mode === 'dark' ? '#28282b' : '#f1eee6',
    minHeight: '100vh',
    width: '100%',
    transition: '.5s'
  }}>
<Router>
  <NavigationBar viewMode = {viewMode} page = {page} setPage = {setPage} currentTime = {currentTime.toLocaleTimeString()} screenSize = {screenSize} mode = {mode} handleModeSelect = {handleModeSelect}/>
  <Routes>
    <Route path='/' element={<Home viewMode = {viewMode} greeting = {greeting} currentTime = {currentTime.toLocaleTimeString()} screenSize = {screenSize} mode = {mode}/>} />
    <Route path='/contact' element={<Contact viewMode = {viewMode} mode = {mode}/>}/>
    <Route path='/about' element={<About mode = {mode}/>}/>
    <Route path='/projects' element={<Projects mode = {mode}/>}/>
  </Routes>
    
</Router>
</div>
)


};

export default App;
